module.exports = __webpack_public_path__ + "static/hero-intro-img-desktop-41b872a8b2c08f1fbcefa6bcf54beef7.png";